import {Input, Form, Row, Col, Spin, Tooltip, ConfigProvider, Select, Switch} from 'antd'
import {useEffect, useState} from "react";
import {SDrawerOrModal, STitle} from "shj-components";
import {salesTemplateDetail} from "@/services/customerServices.ts";

const DetailModal = props => {
  const {open, onClose, fn, record, templateType} = props
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState({})

  const title = templateType === 'CLUE' ? '商机计划' : '销售计划'

  useEffect(() => {
    form.resetFields()
    if (open && record.id) getInfo()
  }, [open]);

  const getInfo = () => {
    setLoading(true)
    salesTemplateDetail(record.id).then(res => {
      form.setFieldsValue(res)
      setDetail(res)
    }).finally(() => setLoading(false))
  }

  return (
      <SDrawerOrModal
          mode={'drawer'}
          open={open}
          onCancel={onClose}
          width={1000}
          title={`${title}详情`}
          antdProps={{
            footer: null
          }}
      >
        <div style={{padding: '0 10px 0 5px'}}>
          <Spin spinning={loading}>
            <ConfigProvider theme={{components: {Form: {labelColor: '#87888A', itemMarginBottom: 12}}}}>
              <Form
                  style={{padding: "10px 0"}}
                  form={form}
                  initialValues={{items: [{}]}}
              >
                <STitle title={'选择组织'} style={{marginBottom: 10}}/>
                <Form.Item hidden name='id'><Input/></Form.Item>
                <Row gutter={10}>
                  <Col span={24}>
                    <Form.Item label={`${title}名称`} name='name'>
                      {detail.name}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label={'选择门店'} name='storeIds'
                               mode={'multiple'}
                    >
                      <div style={{marginTop: 5}}>{detail.storeNames?.join(', ')}</div>
                    </Form.Item>
                  </Col>
                  {templateType !== 'CLUE' && <Col span={24}>
                    <Form.Item label={'需求标签'} name='types'>
                      {detail.typeNames?.join(', ')}
                    </Form.Item>
                  </Col>}
                  <Col span={24}>
                    <Form.Item label={'适用阶段'} name='templateType' hidden>
                      {detail.templateTypeName}
                    </Form.Item>
                  </Col>
                  {templateType === 'CLUE' && <Col span={24}>
                    <Form.Item label={'适用渠道'} name='channelIds'
                               mode={'multiple'}
                    >
                      <div style={{marginTop: 5}}>{detail.channelNames?.join(', ')}</div>
                    </Form.Item>
                  </Col>}
                  {templateType !== 'CLUE' && <Col span={24}>
                    <Form.Item label={'适用产品'} name='product'>
                      {detail.productName}
                    </Form.Item>
                  </Col>}
                </Row>
                <STitle title={'设置节点规则'}/>
                <Form.List name="nodes">
                  {(fields, {add, remove}) => (
                      <div style={{display: 'flex', flexDirection: 'column'}}>
                        {fields.map((field) => (
                            <div key={field.key}>
                              <Row>
                                {/*<Col span={4} style={{padding: 10, borderRadius: 5, textAlign: 'right'}}>*/}
                                {/*<div>
                                <ArrowUpOutlined className={field.key <= 0 ? styles.icon_disabled : styles.icon}/>
                                <ArrowDownOutlined className={field.key >=2 ? styles.icon_disabled : styles.icon} style={{marginLeft: 5}}/>
                                {field.key ? <MinusCircleOutlined onClick={() => remove(field.key)} className={styles.icon} style={{marginLeft: 5}}/> : null}
                              </div>*/}
                                {/*</Col>*/}
                                <Col span={24}
                                     style={{background: '#F7F8FA', padding: 10, margin: '10px 5px', borderRadius: 5}}>
                                  <Row gutter={20}>
                                    <Col span={16}>
                                      <Form.Item label={`节点【${field.name + 1}】名称`} name={[field.name, 'name']}>
                                        {detail.nodes[field.name]?.name}
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row gutter={20}>
                                    <Col span={8}>
                                      <Form.Item label={'是否触发智能分配'} name={[field.name, 'dispatchFlag']}>
                                        {detail.nodes[field.name]?.dispatchFlag ? '是' : '否'}
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item label={'分配角色是否取直接上级'}
                                                 name={[field.name, 'directSuperiorFlag']}>
                                        {detail.nodes[field.name]?.directSuperiorFlag ? '是' : '否'}
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row gutter={20}>
                                    <Col span={8}>
                                      <Form.Item label={'节点类型'} name={[field.name, 'nodeType']}>
                                        {detail.nodes[field.name]?.nodeTypeName}
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item label={'分配角色'} name={[field.name, 'roleIds']}
                                                 dependencies={[field.name, 'dispatchFlag']}
                                      >
                                        <div style={{
                                          width: '100%',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}>
                                          <Tooltip title={detail.nodes[field.name]?.roleNames?.join(", ")}>
                                            {detail.nodes[field.name]?.roleNames?.join(", ")}
                                          </Tooltip>
                                        </div>
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item label={'销售活动'} name={[field.name, 'task']}
                                                 dependencies={[field.name, 'dispatchFlag']}
                                      >
                                        <div style={{
                                          width: '100%',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}>
                                          <Tooltip title={detail.nodes[field.name]?.taskNames?.join(", ")}>
                                            {detail.nodes[field.name]?.taskNames?.join(", ")}
                                          </Tooltip>
                                        </div>
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item label={'节点职责'} name={[field.name, 'dutyType']}>
                                        {detail.nodes[field.name]?.dutyTypeName}
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item label={'派单方式'} name={[field.name, 'dispatchMethodId']}>
                                        <div style={{
                                          width: '100%',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}>
                                          <Tooltip title={detail.nodes[field.name]?.dispatchMethodName}>
                                            {detail.nodes[field.name]?.dispatchMethodName}
                                          </Tooltip>
                                        </div>
                                      </Form.Item>
                                    </Col>
                                    {field.key <= 0 && <>
                                      <Col span={8}>
                                        <Form.Item label={`当前${title}节点归属公司`} name={[field.name, 'companyId']}>
                                          <div style={{
                                            width: '100%',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                          }}>
                                            <Tooltip title={detail.nodes[field.name]?.companyName}>
                                              {detail.nodes[field.name]?.companyName}
                                            </Tooltip>
                                          </div>
                                        </Form.Item>
                                      </Col>
                                    </>}
                                  </Row>
                                  <Row gutter={20}>
                                    <Col span={8}>
                                      <Form.Item label={'设置进入下一状态条件'}
                                                 name={[field.name, 'nextNodeConditionFlag']}>
                                        {detail.nodes[field.name]?.nextNodeConditionFlag ? '是' : '否'}
                                      </Form.Item>
                                    </Col>
                                    {detail.nodes[field.name]?.nextNodeConditionFlag && <Col span={16}>
                                      <Form.Item label={'当客户满足以下条件时，才能进入当前节点'}
                                                 name={[field.name, 'nextNodeTask']}>
                                        <div style={{
                                          width: '100%',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}>
                                          <Tooltip title={detail.nodes[field.name]?.nextNodeTaskName?.join(", ")}>
                                            {detail.nodes[field.name]?.nextNodeTaskName?.join(", ")}
                                          </Tooltip>
                                        </div>
                                      </Form.Item>
                                    </Col>}
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                        ))}
                      </div>
                  )}
                </Form.List>
              </Form>
            </ConfigProvider>
          </Spin>
        </div>
      </SDrawerOrModal>
  );
}

export default DetailModal
